import React from 'react';
import "../../../css/pages/about.scss";
import aboutUsImage from "../../../images/aboutus/aboutUsImage.png";

function About() {

    return(
        <div className='about-us-container'>
            <p className='title-text'>About Us</p>
            <div className='grid-image-text'>
                <img className='about-us-image-grid' src={aboutUsImage} />
                <div>
                    <p className='content-title-text'>What We Do</p>
                    <p className='content-text'>
                        RS11 has generated valuations for millions of businesses in the United States. By making access to those businesses easy, opportunities for partnership, growth and sale are created. RS11 brings new tools to SMBs at a fraction of the cost and friction of traditional methods. These tools, and more, are at the core of what we do.
                    </p>
                </div>
            </div>
            <p className='content-text'>The RS11 Global Marketplace will help businesses by:</p>
            <ul>
              <li className='content-text'>Benchmarking performance against competitors and themselves.</li>  
              <li className='content-text'>Driving awareness of their business on a local and global level.</li>
              <li className='content-text'>Creating an easy, efficient way to buy and sell businesses.</li>
              <li className='content-text'>Securing loans, capital, crowdfunding and other financings.</li>
              <li className='content-text'>Building communities of shared business interest.</li>
              <li className='content-text'>Facilitating fractional ownership.</li>
            </ul>
        </div>
    )
}

export default About;
